/**
 * 转换成formdata
 * @param {string} dataURI
 * @returns {Blob}
 *
 * @source http://stackoverflow.com/questions/4998908/convert-data-uri-to-file-then-append-to-formdata
 */
function dataURItoBlob(dataURI = '') {
  // 清除多余的空白字符
  dataURI = dataURI.replace(/\s+/g, '');

  let byteString;
  const [head, data] = dataURI.split(',');
  if (head.indexOf('base64') >= 0) {
    byteString = atob(data);
  } else {
    byteString = unescape(data);
  }

  // separate out the mime component
  const type = head.split(':')[1].split(';')[0];

  // write the bytes of the string to a typed array
  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  return new Blob([ia.buffer], { type });
}

export default dataURItoBlob;
